import { JsonObject } from './types';

type CamelObject = JsonObject;
type SnakeObject = JsonObject;

/**
 * キャメルケースのオブジェクト構造を再帰的にスネークケースに変換する
 * @param camelObject キャメルケースのオブジェクト
 * @returns {SnakeObject} - スネークケースのオブジェクト
 */
export const toSnakeCaseObject = (camelObject: CamelObject): SnakeObject =>
  Object.keys(camelObject).reduce((resultObject, key) => {
    const snakeKey = camelToSnake(key);
    const camelValue = camelObject[key];

    if (camelValue === null) {
      return Object.assign(resultObject, { [snakeKey]: camelValue });
    }
    if (typeof camelValue === 'object' && !Array.isArray(camelValue)) {
      return Object.assign(resultObject, { [snakeKey]: toSnakeCaseObject(camelValue) });
    }
    if (Array.isArray(camelValue)) {
      return Object.assign(resultObject, {
        [snakeKey]: camelValue.map(value =>
          typeof value === 'object' && value !== null ? toSnakeCaseObject(value) : value
        ),
      });
    }

    return Object.assign(resultObject, { [snakeKey]: camelValue });
  }, {});

/**
 * キャメルケースの文字列をスネークケースに変換する
 * @param str キャメルケース文字列
 * @returns スネークケースの文字列
 */
/**
 * キャメルケースの文字列をスネークケースに変換する
 * @param str キャメルケース文字列
 * @returns スネークケースの文字列
 */
export const camelToSnake = (str: string): string =>
  str
    .split(/(?=[A-Z])/)
    .join('_')
    .toLowerCase();
